import React, { useEffect, useState } from 'react';
import './ConfirmDialog.scss';
import HighlightOffIcon from '@material-ui/icons/HighlightOff';
import { Button } from '@material-ui/core';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';


import { FxInput, AlertService } from '../fx-core';

const ConfirmDialog = (props: any) => {
  console.log("ConfirmDialog props:", props);
  const [comments, setComments] = useState("");
  const [selectedReason, setSelectedReason] = useState<number | string>("");
  const [error, setError] = useState<string | null>(null);

  const defaultQues = [
    { id: 1, message: "Buyer not happy with the Item" },
    { id: 2, message: "Wrong item Given" },
    { id: 3, message: "Item damaged / Broken" },
    { id: 4, message: "Item Out of Stock (after Order)" },
    { id: 5, message: "Delayed Delivery or Service Issues" },
    { id: 6, message: "Cancellation on non-refundable item" },
  ];

  const handleClose = () => {
    props.handleDialogClose();
  };

  // const handleReasonChange = (e: React.ChangeEvent<HTMLInputElement>) => {
  //   const value = e.target.value;
  //   setSelectedReason(value);

  //   if (value === "other") {
  //     setComments(""); // force user input
  //   } else {
  //     const reason = defaultQues.find((q) => q.id === Number(value));
  //     setComments(reason ? reason.message : "");
  //   }
  // };
const cancellationReasons = props.reasonsList || defaultQues;

  const handleReasonChange = (e: React.ChangeEvent<HTMLInputElement>) => {
  const value = e.target.value;
  setSelectedReason(value);

  if (value === "other") {
    setComments(""); // force user input
  } else {
    const reason = cancellationReasons.find((q) => q.id === Number(value));
    setComments(reason ? reason.message : "");
  }
};
const confirmDialog = () => {
  if (props.action === "cancel") {
    if (!selectedReason) {
      setError("Please select a cancellation reason");
      return;
    }

    if (selectedReason === "other" && !comments.trim()) {
      setError("Comments are required when selecting Other");
      return;
    }

    // Determine final comment to send
    let finalCommentToSend = comments;
    if (selectedReason !== "other") {
      const reason = cancellationReasons.find((q) => q.id === Number(selectedReason));
      finalCommentToSend = reason ? reason.message : "";
    }

    // Call parent callback with action and final comment string
    props.onConfirmCallback(props.action, finalCommentToSend);
    setError(null);
    return;
  } else {
    props.onConfirmCallback();
  }
};



  // const confirmDialog = () => {
  //   if (props.action === "cancel") {
  //     if (!selectedReason) {
  //       setError("Please select a cancellation reason");
  //       return;
  //     }

  //     if (selectedReason === "other" && !comments.trim()) {
  //       setError("Comments are required when selecting Other");
  //       return;
  //     }

  //     // Build payload
  //     const payload: any = {
  //       comments,
  //     };

  //     if (selectedReason !== "other") {
  //       payload.cancellationReasonId = Number(selectedReason);
  //     }

  //     props.onConfirmCallback(props.action, payload);
  //   } else {
  //     props.onConfirmCallback();
  //   }
  // };

  return (
    <div className="confirmContainer confirm-dialog">
      {/* header */}
      <div className="row justify-content-between title-font px-3">
        <div className="py-1 pl-3">
          <span>Confirm</span>
        </div>
        <div className="text-right pointer my-auto">
          <i className="fas fa-times-circle font-16 pr-3" onClick={handleClose}></i>
        </div>
      </div>

      {/* message */}
      <div className="m-2 pl-3">{props.message}</div>

      {/* cancellation reasons */}
      {props.action === "cancel" && (
        <div className="row m-2">
          <div className="col-12 font-14">
            <FormControl>
              <RadioGroup
                name="cancel-reason"
                value={selectedReason}
                onChange={handleReasonChange}
              >
               {cancellationReasons.map((cancel) => (
                  <FormControlLabel
                    key={cancel.id}
                    value={cancel.id}
                    control={<Radio />}
                    label={cancel.message}
                  />
                ))}

                <FormControlLabel value="other" control={<Radio />} label="Other" />
              </RadioGroup>
            </FormControl>

        {selectedReason === "other" && (
<FxInput
  name="comments"
  variant="outlined"
  label="Cancelled Remarks"
  size="small"
  value={comments}
  onValueChange={(val: any) => {
    // If FxInput returns { value: "typed text" }
    if (val && typeof val === "object" && "value" in val) {
      setComments(val.value);
    } 
    // If FxInput directly returns string
    else if (typeof val === "string") {
      setComments(val);
    }
  }}
/>

)}

          </div>
          {error && <div className="error">{error}</div>}
        </div>
      )}

      {/* footer buttons */}
      <div className="row justify-content-end pb-2 pr-4">
        <div>
          <span className="mr-2">
            <Button variant="contained" size="small" onClick={handleClose}>
              No
            </Button>
          </span>
          <span>
            <Button variant="contained" size="small" color="primary" onClick={confirmDialog}>
              Yes
            </Button>
          </span>
        </div>
      </div>
    </div>
  );
};


export default ConfirmDialog;